import {FormEnvironment} from "@fd/Types.ts";
import {DONT_RING, RingSelectLabels} from "@t/fd/editor/RingSelect.ts";

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

export function formatRingInterval(env:FormEnvironment, ms:number, labels?: RingSelectLabels):string {
	// Prepare labels
	let lb:RingSelectLabels;
	lb = labels ? { ...labels } : {};
	if (!lb.before) lb.before = env.msg("ring.before");
	if (!lb.at) lb.at = env.msg("ring.exact");
	if (!lb.after) lb.after = env.msg("ring.after");
	if (ms === DONT_RING) return "< "+env.msg("ring.none")+" >";
	if (Math.abs(ms) < 1000) return lb.at;	// everything bellow one second is considered to be at the event

	const rules = new Intl.PluralRules(Server.lang);
	const before = ms > 0;
	ms = Math.abs(ms);

	let weeks = Math.floor(ms / WEEK);
	let remaining = ms % WEEK;
	let days = Math.floor(remaining / DAY);
	remaining = remaining % DAY;
	let hours = Math.floor(remaining / HOUR);
	remaining = remaining % HOUR;
	let minutes = Math.floor(remaining / MINUTE);
	remaining = remaining % MINUTE;
	let seconds = Math.floor(remaining / SECOND);

	const parts:string[] = [];
	if (weeks > 0) parts.push(env.msg('ring.week.' + rules.select(weeks), weeks));
	if (days > 0) parts.push(env.msg('ring.day.' + rules.select(days), days));
	if (hours > 0) parts.push(env.msg('ring.hour.' + rules.select(hours), hours));
	if (minutes > 0) parts.push(env.msg('ring.minute.' + rules.select(minutes), minutes));
	if (seconds > 0) parts.push(env.msg('ring.second.' + rules.select(seconds), seconds));

	const joinWord = env.msg("ring.join");
	return commaAndJoin(joinWord, parts) + " " + env.msg(before ? lb.before : lb.after);
}

function commaAndJoin(andWord:string, parts:string[]):string {
	let result = "";
	for (let i = 0; i < parts.length; i++) {
		const part = parts[i];
		if (i > 0) {
			if (i === parts.length - 1) result += " " + andWord + " ";
			else result += ", ";
		}
		result += part;
	}
	return result;
}